import { Flex, PaymentPane, Spacing } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'

import { DemoInvoiceSendChannel } from '../../enums/demoInvoiceSendChannel'
import { DemoInvoiceSentState } from '../../types/demoInvoiceSentState'
import { getDemoInvoicePaymentPaneData } from '../../utils/getDemoInvoicePaymentPaneData'
import { DemoInvoicePreview } from '../DemoInvoicePreview'
import { DemoInvoiceSentDetailsCard } from '../DemoInvoiceSentDetailsCard'
import { DemoInvoiceSentEInvoiceStatusCard } from '../DemoInvoiceSentEInvoiceStatusCard'
import { DemoInvoiceSentTimeline } from '../DemoInvoiceSentTimeline'
import * as Styled from './styles'

interface DemoInvoiceSentViewProps {
  sentState: DemoInvoiceSentState
}

export const DemoInvoiceSentView = ({ sentState }: DemoInvoiceSentViewProps): ReactElement => {
  const { channel, companyName, dueDate, grossTotal, htmlFiles, issueDate, sentAt } = sentState

  const paymentPaneData = useMemo(() => getDemoInvoicePaymentPaneData({ dueDate, grossTotal }), [dueDate, grossTotal])

  return (
    <Flex justifyContent="center">
      <Flex flexDirection="column" gap={Spacing.S24} width="fit-content">
        <PaymentPane {...paymentPaneData} />
        <Flex gap={Spacing.S24} justifyContent="center" width="fit-content">
          <DemoInvoicePreview htmlFiles={htmlFiles} isLoading={false} />
          <Flex.Item>
            <Styled.SidebarWrapper>
              <DemoInvoiceSentDetailsCard companyName={companyName} issueDate={issueDate} />
              {channel === DemoInvoiceSendChannel.EInvoice && <DemoInvoiceSentEInvoiceStatusCard />}
              <DemoInvoiceSentTimeline channel={channel} sentAt={sentAt} />
            </Styled.SidebarWrapper>
          </Flex.Item>
        </Flex>
      </Flex>
    </Flex>
  )
}
